import { ArcElement, Chart as ChartJS, Legend, RadialLinearScale, Title, Tooltip } from 'chart.js'
import React, { useEffect, useRef, useState } from 'react'
import { PolarArea } from 'react-chartjs-2'
import { log } from '../../../services/LogService'
import ErrorMsg from '../../ui/ErrorMsg'
import { ChartProps } from '../types'
import prepareChartData from '../utils/PrepareChartData'

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend, Title)

export default function PolarAreaChart({ endpoint, serverData, chartFor }: ChartProps) {
    const [className] = useState('PolarAreaChart-' + new Date().getTime())
    const chartRef = useRef<ChartJS>(null)
    const [chartData, setChartData] = useState({ datasets: [], labels: [] })
    const _options = serverData?.chartOptions?.polarArea
    const [options, setOptions] = useState(_options)
    const _height = serverData?.chartOptions?.polarArea?.chart?.canvas.height
    const [height, setHeight] = useState<string | number | undefined>(_height)
    try {
        useEffect(() => {
            const chart = chartRef.current
            if (!chart) {
                return
            }

            const { datasets, options, labels } = prepareChartData({
                chartType: 'polarArea',
                endpoint,
                serverData,
                chart,
            })
            // @ts-ignore
            setChartData({ labels, datasets })
            setOptions(options)
        }, [chartFor, JSON.stringify(serverData)])

        // @ts-ignore
        return <PolarArea ref={chartRef} data={chartData} options={options} type={'pie'} height={height} />
    } catch (e) {
        log.error(className, 'MSG001', { endpoint })
        return <ErrorMsg />
    }
}
